<template>

   <div class="container">
       <router-link class="btn-back" to="/actualites"><i class="fas fa-long-arrow-alt-left"></i> Retourner à la page précédente</router-link>
       <div class="title">Vivescia choisi Agrivitech pour créer sa Bourse aux Semences</div>
       <div class="highlighted">Une solution web simple permettant aux adhérents de publier les annonces de semences non utilisées</div>
       <div class="btn-back mb-5">Publié le 16/10/2020 à 15:38 par Nicolas VILMART</div>

        <strong >
            <p>Disponible depuis mi-septembre 2020, une plateforme d’échange semences est proposée par la Coopérative à ses associéscoopérateurs. Son objectif ?  <br>
            Permettre aux agriculteurs à qui ils restent des semences de se délester de leur stock et de participer au
            réapprovisionnement des autres, à proximité de chez eux, pour finir leur semis</p>
        </strong>

        <div class="highlighted">Un nouveau service de proximité disponible sur PC ou smartphone</div>

        <p>
            Cette pratique jusqu’alors réalisée en gestion manuelle par les équipes de chaque silo, entre dans une nouvelle ère, avec une bourse
d’échange semences digitalisée et accessible sur l’extranet de la coopérative. <br>   
L’application a deux vocations principales : assurer la traçabilité des semences implantées et améliorer la réactivité en ces périodes
de réappro. <br>
En effet, un agriculteur à qui il reste des doses de semences peut poster une annonce sur l’application qui lui propose le numéro de
lot de la ou des doses concernées. Ce numéro de lot sera confirmé également par l’acquéreur en fin de transaction pour garantir la
traçabilité. La Coopérative se charge ensuite de l’administratif, notamment la gestion des avoirs et des facturations. Par contre, c’est
aux deux agriculteurs d’organiser ensemble la logistique des semences d’une ferme à l’autre.

        </p>

        <div class="row">
        <div class="col-md-6">
            <img src="@/assets/img/capture_boursedechange.png" class="img-fluid zoomIn" alt="">
        </div>
        <div class="col-md-6">
            <img src="@/assets/img/capture_boursedechange2.png" class="img-fluid zoomIn" alt="">
        </div>
    </div>
        
        <div class="highlighted">Un levier de réduction des charges pour la Coopérative et d’optimisation de la trésorerie pour l’agriculteur</div>

        <p>
            Chez VIVESCIA, le réappro en cours de campagne représente 10 % des volumes totaux de semences certifiées produites. Ce faible
volume est beaucoup plus coûteux à produire au sein des unités de production de semences car les quantités à produire par référence sont faibles, 
or le nombre de salariés reste identique… <br>
Améliorer les flux de semences non utilisées entre les associés-coopérateurs de VIVESCIA est un levier de réduction des charges
pour la Coopérative. <br>
D’autre part, conserver des semences non utilisées n’est pas non plus une stratégie des plus économiques pour l’agriculteur. En lui
offrant la possibilité de remettre ces dernières sur le marché, sa gestion des stocks est optimisée et il se prémunit du risque qualité
de germination l’année suivante.
        </p>

        <div class="highlighted">Des perspectives</div>

        <p>
            Alors que les semis sont en cours, quelques annonces commencent à apparaître sur l’application. <br>
Un service disponible uniquement aujourd’hui pour les semences certifiées station, mais qui demain, aura vocation à se
perfectionner et pourrait bien se déployer sur d’autres familles de produits en respectant la réglementation en vigueur pour
chacune d’entre elles.

        </p>

 
            <div class="row clients-logo text-center">
                <div class="col-lg-3 logoContainer"><img src="@/assets/img/vivescia.png" alt="Logo Vivescia"></div>
                <div class="col text-left mt-4">
                    <div><strong>Jean-Marie ANTOINE</strong> <a href="https://www.linkedin.com/in/jean-marie-antoine-541477112/"><i class="fab fa-linkedin"></i></a>, Responsable Marché Semences pour Vivescia</div>
                    <div><strong>Emmanuel JAILLANT</strong>, Directeur Semences pour Vivescia </div>
                </div>
            </div>

       
   </div>
</template>

<script >

export default {
    name: 'News',
    components:{},
    props:{},
    data(){
        return{
            title: "Vivescia lance sa Echange semences",
            description: 'Une solution web simple permettant aux adhérents de publier les annonces de semences non utilisées.',
            url: 'https://www.agrivitech.com.com/actualites/bourse-vivescia',
            image: process.env.BASE_URL +"img/capture_boursedechange.png"
        }
    }
}
</script>

<style lang="scss" scoped>
    

    .zoomIn {
        transition: transform .2s;
        position: relative;;
        &:hover{
           transform: scale(1.9);
           position: absolute;
           z-index: 10;
        }
    }


</style>